import React from 'react';
import { connect } from 'react-redux';
import DocumentPaneComponent from './component';
import { WithTranslation, withTranslation } from 'react-i18next';
import _ from 'lodash';
import RouteLeavingGuard from '../../../shared/routeLeavingGuard/routeLeavingGuard';
import history from '../../../history';
import { messageService } from '../../../services/messageService';
import { getProject } from '../../../shared/util';
import { v4 as uuidv4 } from 'uuid';
import {
  getAllProjectDropdowns,
  getProjectDefinition,
  getProjectHeaderDetails,
} from '../../../reducers/projectReducer';


import { formData, Quality } from '../../../types/quality';

import { readByQualityId, saveFormData } from '../../../reducers/qualityReducer';

export interface State {
  isDirty: boolean;
  redirect: boolean;
  loading: boolean;
  isClear: boolean;
  isEdit: boolean;
  isCostModalOpen: boolean;
  showPrint: boolean;
  isApproved: boolean;
  ledgerDropDowns: { key: string; text: string }[];
  generalLedger: string;
  resourceData: any;
  openPOResourceModal: boolean;
  uid: string | null;
  qlId: any;
}

interface Props extends WithTranslation {
  qlDropDowns: any;
  saveFormData: (data: Quality) => void;
  getAllProjectDropdowns: () => void;
  test: string;
  formData: any;
  readByQualityId: (id: string) => void
  qlId: any;
  isNewQL: boolean;
}

class DocumentPane extends React.Component<any, any> {
  subscription: any;
  submitExternal: any;
  form: any;

  constructor(props: any) {
    super(props);
    this.state = {
      isDirty: false,
      isEdit: false,
      redirect: false,
      loading: false,
      formData: formData,
      showPrint: false,
      isApproved: false,
      uid: null,
      isClear: false,
    };
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if (
      prevProps.isNew !== this.props.isNew ||
      prevProps.uid !== this.props.uid
    ) {
      if (this.props.isNew) {
        const formData = this.state.formData;
        formData.id = this.props.uid;
        this.setState({ formData, isClear: false });
      }
    } else {
    }

    if (prevProps.qlId !== this.props.qlId) {
      if (this.props.qlId) {
        this.props.readByQualityId(this.props.qlId);
      }
    }

    if (prevProps.formData !== this.props.formData) {
      if (!this.state.isDirty) {
        if (!_.isEmpty(this.props.formData)) {
          const formData = this.props.formData;
          this.setState({ formData: formData, isClear: false });
        }
      } else {
        if (this.props.isNew && _.isEmpty(this.props.formData)) {
          const formData = this.state.formData;
          this.setState({ formData: formData, isClear: false });
        }
      }
    }
  }

  componentDidMount() {
    // get document pane dropdowns
    this.props.getAllProjectDropdowns();
    //    this.setState({ uid: uuidv4(), isClear: this.props.isNewQL });
    this.setState({ uid: uuidv4(), isClear: true });

    this.subscription = messageService.getMessage().subscribe((data: any) => {
      if (data) {

        if (data.data.isNewQL) {
          if (getProject()) {
            this.setState({ uid: uuidv4(), isClear: true });
          } else {
            this.setState({ uid: uuidv4(), isClear: true });
          }

          if (this.form) {
            this.form.reset();
            this.form.resetFieldState('name');
            //   this.form.resetFieldState('header.cpcResourceTitle');
          }
        }
        if (data.data.saveQLData) {
          // this.saveFormData();
          this.submitExternal();
        }
        if (data.data.qlFilter) {
          this.setState({ filter: data.data.ql });
        }
        if (data.data.pdfGenerate) {
          this.setState({ showPrint: true });
        }
      }
    });
    if (getProject()) {
      const projectId = getProject();
      if (projectId) {
        this.props.getProjectHeaderDetails(projectId);
      }
    } else if (this.props.formData?.id) {
      this.props.getProjectHeaderDetails(this.props.formData?.id);
    }
    if (this.props.formData?.id) {

    }
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  handleDiscardChangesNavigate = (path: string) => {
    history.push({
      pathname: path,
      state: { psFilter: this.state.filter },
    });
  };

  setSubmitExternal = (submit: any) => {
    this.submitExternal = submit;
  };

  setForm = (form: any) => {
    this.form = form;
  };


  render() {
    return (
      <div style={{ width: '100%' }}>
        <RouteLeavingGuard
          when={this.state.isDirty}
          navigate={(path) => this.handleDiscardChangesNavigate(path)}
          shouldBlockNavigation={() => {
            return true;
          }}
          handleConfirmation={(isConfirm: boolean) => {
            this.setState({ isDirty: !isConfirm });
          }}
        />
        <DocumentPaneComponent
          submit={(submit: any) => {
            this.setSubmitExternal(submit);
          }}
          createQuality={(qality: Quality) => {
            this.props.createQuality(qality);
          }}
          dropDowns={this.props.dropDowns}
          uid={this.state.uid}
          formData={this.props.formData}
          showProgress={this.props.isLoadingQuality}
          formValues={this.form?.getState()?.values}
          isClear={this.state.isClear}
          isExpand={this.props.isExpand}
          setForm={(form: any) => {
            this.setForm(form);
          }}
          hasChangeIntialFromData={false}
          saveFormData={this.props.saveFormData}
        />

      </div>
    );
  }

}

const mapStateToProps = (state: any) => {
  return {
    isEdit: state.ql.isEdit,
    isNew: state.ql.isNew,
    uid: state.ql.uid,
    projectHeader: state.project.projectHeader,
    showProgressBar: state.ql.showProgressBar,
    selectedProject: state.project.selectedProject,
    dropDowns: state.ql.qlDropDowns,
    qlId: state.ql.qlId,
  };
};

const mapDispatchToProps = {
  saveFormData,
  getProjectHeaderDetails,
  getAllProjectDropdowns,
  getProjectDefinition,
  readByQualityId,
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DocumentPane));
